import { useAuth0 } from "@auth0/auth0-react"

export const CARHARTT_WIP_ORG = "carhartt_wip"

/**
 * Whether the current org is Carhartt-WIP. Kept in a dependency-light hook (no column/table
 * imports) so it can be used by core providers without dragging the heavy column-util graph in.
 */
export function useIsCarharttWip(): boolean {
  const { user } = useAuth0()
  return user?.org_name === CARHARTT_WIP_ORG
}
